/*
  中文
*/
export default {
  promptText: {
    msg1: '成功',
    msg2: '警告',
    msg3: '错误'
  }
}
